import api from '../api';

async function fetchInsurers(params) {
    const response = await api.get('insurers', { params });
    return response.data;
}

export { fetchInsurers };
